import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { GeneralHeaderModel } from 'src/app/model/general/header';
import { generalConsultActions } from 'src/app/store/general/general.action';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GeneralConsultVitalSignService extends BaseService {
  constructor(protected store: Store<any>, protected rest: RestService) {
    super();
  }

  loadConsultHeader = (turn: number): Observable<GeneralHeaderModel> =>
    this.rest
      .get({
        url: `${environment.endpoints.general}/header/{turn}`,
        urlParams: { turn },
      })
      .pipe(
        map((header) => {
          if (header) {
            return header;
          }
          return {} as GeneralHeaderModel;
        })
      );

  isSaving = (): Observable<boolean> =>
    this.store.select('general', 'consult', 'saving');

  save = (
    turn: number,
    body: GeneralHeaderModel
  ): Observable<GeneralHeaderModel> =>
    this.rest
      .post({
        url: `${environment.endpoints.general}/header`,
        body: { ...body, turn },
      })
      .pipe(
        tap(
          () => this.addToSaved(),
          () => this.addToSaved()
        )
      );

  addToSaved = (value: number = 1) =>
    this.store.dispatch(generalConsultActions.addToSavedAction({ value }));
}
